
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqRZ8mZpZtNcWLyzVFhxlmJAjgfNiY8cv2C89V3hu4iBYMeta } from "/codebuild/output/src3498164433/src/src/pages/faq.vue?macro=true";
import { default as menuv1s3pi56odHcyozXKgmhNGGJclCu5M4qozP60jlSk8AMeta } from "/codebuild/output/src3498164433/src/src/pages/menu.vue?macro=true";
import { default as index9Rjc4QRUddF_1AKzzxtds_M5Vx6teHHXPjynw5S9buoMeta } from "/codebuild/output/src3498164433/src/src/pages/index.vue?macro=true";
import { default as contactB4ygiFxrIPUBNgQVV_EcTCB8c9CrslPj24wlVdHfFu8Meta } from "/codebuild/output/src3498164433/src/src/pages/contact.vue?macro=true";
import { default as tutorialuigV_n6HazYVKeVAiOG7ov90qvPXg9a4UFdVDzBbf3sMeta } from "/codebuild/output/src3498164433/src/src/pages/tutorial.vue?macro=true";
import { default as agreementRe1LwwZrKJKAZYgjAl52GehguZqbUDCZco9o62zRX3EMeta } from "/codebuild/output/src3498164433/src/src/pages/agreement.vue?macro=true";
import { default as about_45passmnhVAdzDfT2cJmTlS9JBjs29MIkihu7sDIV2T2t4KpIMeta } from "/codebuild/output/src3498164433/src/src/pages/about-pass.vue?macro=true";
import { default as indexjp5Va6taptLyDIgzIYCWJwfVD_45abtd_iBQBS742k9BIMeta } from "/codebuild/output/src3498164433/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93feBZIlgxU3Rv4PALNP3ZVI0FzT2SM47FKnnLhyLpAGIMeta } from "/codebuild/output/src3498164433/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceHeKC_jhXxMy5Lzt8zWriSRXLVeRlZ6EP8iVx_45nicEwUMeta } from "/codebuild/output/src3498164433/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93NF2tvpiAfVGSGdKk8vqcrZPnMD3ckOU5lHgDvPscC5wMeta } from "/codebuild/output/src3498164433/src/src/pages/notice/[id].vue?macro=true";
import { default as indexReRhgLuLjZwSumToS3510GLnr2OzhEjT4u1Y8hPkFNQMeta } from "/codebuild/output/src3498164433/src/src/pages/coupon/index.vue?macro=true";
import { default as indexdMY8SaHqOBvNYTlvmP1u9_ndf79_GJ4lLTzahj9ZJ9wMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/index.vue?macro=true";
import { default as indexCarp_45wjFZn0ZasOppqaEGo14sPwsTX9ndYygujkviJAMeta } from "/codebuild/output/src3498164433/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93Ek_45R78yt1kfkHtqz2K7nh3JHaqcX_45eMKgoacplUPqfoMeta } from "/codebuild/output/src3498164433/src/src/pages/parking/[id].vue?macro=true";
import { default as indexcIf_455ScgyjOXwFqJuHiYpwJ6ufxNBKaYBlgTmSHbrcYMeta } from "/codebuild/output/src3498164433/src/src/pages/history/index.vue?macro=true";
import { default as indexxhozS3ZTk8KvSuBl1SbhRk9cnNvVetCAINHA5GAzxO8Meta } from "/codebuild/output/src3498164433/src/src/pages/monthly/index.vue?macro=true";
import { default as indexTHgTp9_ZyrB5KJI7y1azq4br7IgT4eOHQXo0fXh27nAMeta } from "/codebuild/output/src3498164433/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexz8VxTwV6deQUGwUwcTWBZv4IHqTGc3CsgWcVcGqx9dsMeta } from "/codebuild/output/src3498164433/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavitUYN8_RJCcpAS5CojIZaTiTQoIxpKnxre9JBaQNytrYMeta } from "/codebuild/output/src3498164433/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editPGEDTBMEwG7MKAey0QDuT9PP88_45ln5wI1p71ssCA7hQMeta } from "/codebuild/output/src3498164433/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementpw04Iy7aZHLaBHaQcKCbEwmvgF_9yl3iTzxpPAO1zA4Meta } from "/codebuild/output/src3498164433/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexSWefmiUOZLOnT42jGdFD_1O5FEaLqG6EkIagGbV7DfMMeta } from "/codebuild/output/src3498164433/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dsGm2F46r54cpIDu3j4DUOcEmgr5ZUS7zl_45xfKqV5cWwMeta } from "/codebuild/output/src3498164433/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmjmTFntuek9QNUD33kw1U8G8mRV3_kdZut_ONDz38gtQMeta } from "/codebuild/output/src3498164433/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexAlkwKl3iXD13RdS_4544mkSJeTOw2LzskT1CiP4cmQAbUMeta } from "/codebuild/output/src3498164433/src/src/pages/card/create/index.vue?macro=true";
import { default as indexCx_451QGMMd4LwAvdGib5trC1It_45r3_bjmJZ1_45dkeZVW4Meta } from "/codebuild/output/src3498164433/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmqMxmdY3ffzVWn1sOOfnRzvKouVDjGOjOArVX0NHUbkkMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmPV5CT6d6X0o4SKOZ5sgLZ3_45pg_DgNQhu3aQJIsBfNssMeta } from "/codebuild/output/src3498164433/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeac_45Er4grEfyIY5IQPTpIysmlARvjC5VqM2xTyxXar5cMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/complete.vue?macro=true";
import { default as registerN_45ccBm_6YL3rNoqVN2rmNu9BQhWziqKhPr2JhIrNixoMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93xDjiSixR8TNyRywtFYTKx_HmQ1CSC_zs6bxGVVwq1IYMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmho31OK9OmQgDf3Y_DwoGKC9veN_45HmYlYOWNRUrmonTUMeta } from "/codebuild/output/src3498164433/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93eBP8kohdt2nM3_45yiAHVk_45JdxGjRf0egQYNNd_ZFIDrkMeta } from "/codebuild/output/src3498164433/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexCKMChkOealB6x6_45WBAv_Xg_4I99ybyo62K3IkgEBUsAMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeQEUPB4RcK8T9M6bv_45Dq4RMEtSyb4m79lGDLqVG7Ra6MMeta } from "/codebuild/output/src3498164433/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeyOvsD5tgQgQ5T5tdkhHJyvGVWjDZuAD_rPc_45mACM3bUMeta } from "/codebuild/output/src3498164433/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete7itW0Ve_45g9HVJFqZaBxC1y8e6QVlI8A2AGhklQfQ_NwMeta } from "/codebuild/output/src3498164433/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerebi2_45LKtmM_5wjj0Q_F76mynwn5QHAmtXEGj6PPGSKYMeta } from "/codebuild/output/src3498164433/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeip9NR2CcKoOfnxb9MuAeJKrro9yT_45Z9_frsjxBp66qMMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index82FIpwE6cygz4G4uafGlcpVOj7vXorLing0BQbex_45FYMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirma85duOa4xWXaFLiPrZkU_r9oX6TZc_45xnKW5PkMOPoNMMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completexcBMNvY58WgKmuSgD_45f6UUtNOyEUTiK_XHo15spSi90Meta } from "/codebuild/output/src3498164433/src/src/pages/reset-password/complete.vue?macro=true";
import { default as index2J_45BGbp3adm1bEcJq_450EFpfBCsKmksDEPYxsgEgcxLcMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93uLHNLjOuM7o72emUGoKPXKyu8v2kCCCo_45S8aYFddqvsMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completerqdvVBbg8TvdxYeQL_jOpo0j5_45_SuqWv5oNMBiLoq08Meta } from "/codebuild/output/src3498164433/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasjK8SBTRUGN3idBbDiB2Q6bw_458wOdeY05rbn2o_45SHUuwMeta } from "/codebuild/output/src3498164433/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleNTxOnd8KDp98PBDEmgr2lw9irdsCTHbp8YK0amoGpbYMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailbfF4QC_8tt6MEoi7nJQDcNRlGBPzqE45rQFDDxeJNkQMeta } from "/codebuild/output/src3498164433/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmJkVbXNTEsl7KRQ18Mj3SdmAO9akO0ugKGqscHhh5QaAMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentcDRzfoaFz_45828jkml3ctQi7aYYGF_45gTmfyMEJM6BL1wMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmInp6gY_BlynwLIeOObSn8O48Op79sFrTWtHdLgiOMIQMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatesToAPf8qy80adxJHxVOLucY_45tCFdpQD8T9guaY5qQjMMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeRvSVoWea5BPsh8h6m_xF1dmu51VhQ1nC8r3GvYOoRQIMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeh3bySTOsmvAhly3DvhEAIBwk_ON1TfZkN3YJTSinLGAMeta } from "/codebuild/output/src3498164433/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordrqvYiPGgNAkE8oIAUhADHFrwMP7VaQil74TCtevalxIMeta } from "/codebuild/output/src3498164433/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasrkB9X9ylP28KXKonJ2A3bIq8OKY5bE_lQZdtCWXscFUMeta } from "/codebuild/output/src3498164433/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register5fYxqVKz92J_TltILq8_45eh_45pZ36TlU0vtkG6evX_hAsMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code_Dw6KBzWXJKI4nllmSrI60ktQhcS8n19KEG_45pyBjSXcMeta } from "/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as index1PIglUplf975o41jRHfv5eUd2FHIAPW87SjFwCIpHIkMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as index0WgqQ_45SxYBZAtlGMUrFU_45ioPgO9v2DEHqtR8r_PI6d8Meta } from "/codebuild/output/src3498164433/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index_45JQ8PH_45_DlbP_PvVZ3UMMqByKtsLjlxwkmo7ebA3iM4Meta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index02GUXXlgvbmsSSaOym4DPR52cMFG13zjBTFcbR_45MGhgMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateHygXS33fayUyGDNokPlgBS9_45jUQCEAMerN3lydh41k0Meta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeJN9zx3YVus9KBftDJZYTePWepLPuWvclbWUARm3FDCcMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmxgv4wIs0uHYb8UoWQB9upzmB2oUIl3CBbF9PmpYDgKwMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexK_45VIjHAQS7coBZsQdwlfN4Gtr98Wf_45T3UtfAkBqf09oMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete2acIfdKtI5rDvBbxJYevtATOt0aF0Qu7NopDPCafI7YMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateKh5yWyaJWDn7DqUtXuo4JK7Pyqwb_45ZUtefj8ulCIwa4Meta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexoqI_ZB4o5lpgN6oEGAwiluueLa6F1RuYI6wVa2hjBNoMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index84_mHqWXsWAfIjd1NWsg2Kx_45L_45aNd6GsBl7ly81GhWIMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete3eI5DizHmTLOiRVHVavXAH_jUdbSj1LMgeoG_45y2rs5gMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexzb2LrMcNVKXmXEAkWTHRHRsvrxPQ6bzqI6dUoV8_9nEMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeQUdDAQnlNhtUkW1nRzdhOWUn3j0kKpFUPF2RB5uC_45CgMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index2Ku5dHrxMTNa0yILKWcDlaRE7Umedl7uSB0bKGy3aCwMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexcFtmXdtFLo8cNUhRCZ4QYRnYD4T_45pvrZ9r_FG_L0eb4Meta } from "/codebuild/output/src3498164433/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexUXre5athzis0NMNM2tQ9d2jWG9ZcAHKLvWmReabopAUMeta } from "/codebuild/output/src3498164433/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateSpYAaU4VannCLqD0ZrbuG3MkOvbthGXieqNfd8xLyUQMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmhv4syLY9b2D0WboFEpjFJ7C_7MkRooCTR2eUBI_459VgUMeta } from "/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuv1s3pi56odHcyozXKgmhNGGJclCu5M4qozP60jlSk8AMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(index9Rjc4QRUddF_1AKzzxtds_M5Vx6teHHXPjynw5S9buoMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexReRhgLuLjZwSumToS3510GLnr2OzhEjT4u1Y8hPkFNQMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexcIf_455ScgyjOXwFqJuHiYpwJ6ufxNBKaYBlgTmSHbrcYMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexTHgTp9_ZyrB5KJI7y1azq4br7IgT4eOHQXo0fXh27nAMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexz8VxTwV6deQUGwUwcTWBZv4IHqTGc3CsgWcVcGqx9dsMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexAlkwKl3iXD13RdS_4544mkSJeTOw2LzskT1CiP4cmQAbUMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmqMxmdY3ffzVWn1sOOfnRzvKouVDjGOjOArVX0NHUbkkMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmPV5CT6d6X0o4SKOZ5sgLZ3_45pg_DgNQhu3aQJIsBfNssMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeac_45Er4grEfyIY5IQPTpIysmlARvjC5VqM2xTyxXar5cMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerN_45ccBm_6YL3rNoqVN2rmNu9BQhWziqKhPr2JhIrNixoMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmho31OK9OmQgDf3Y_DwoGKC9veN_45HmYlYOWNRUrmonTUMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeQEUPB4RcK8T9M6bv_45Dq4RMEtSyb4m79lGDLqVG7Ra6MMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeyOvsD5tgQgQ5T5tdkhHJyvGVWjDZuAD_rPc_45mACM3bUMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete7itW0Ve_45g9HVJFqZaBxC1y8e6QVlI8A2AGhklQfQ_NwMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerebi2_45LKtmM_5wjj0Q_F76mynwn5QHAmtXEGj6PPGSKYMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirma85duOa4xWXaFLiPrZkU_r9oX6TZc_45xnKW5PkMOPoNMMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completexcBMNvY58WgKmuSgD_45f6UUtNOyEUTiK_XHo15spSi90Meta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(index2J_45BGbp3adm1bEcJq_450EFpfBCsKmksDEPYxsgEgcxLcMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completerqdvVBbg8TvdxYeQL_jOpo0j5_45_SuqWv5oNMBiLoq08Meta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleNTxOnd8KDp98PBDEmgr2lw9irdsCTHbp8YK0amoGpbYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailbfF4QC_8tt6MEoi7nJQDcNRlGBPzqE45rQFDDxeJNkQMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmJkVbXNTEsl7KRQ18Mj3SdmAO9akO0ugKGqscHhh5QaAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentcDRzfoaFz_45828jkml3ctQi7aYYGF_45gTmfyMEJM6BL1wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmInp6gY_BlynwLIeOObSn8O48Op79sFrTWtHdLgiOMIQMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeRvSVoWea5BPsh8h6m_xF1dmu51VhQ1nC8r3GvYOoRQIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeh3bySTOsmvAhly3DvhEAIBwk_ON1TfZkN3YJTSinLGAMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordrqvYiPGgNAkE8oIAUhADHFrwMP7VaQil74TCtevalxIMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register5fYxqVKz92J_TltILq8_45eh_45pZ36TlU0vtkG6evX_hAsMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code_Dw6KBzWXJKI4nllmSrI60ktQhcS8n19KEG_45pyBjSXcMeta || {},
    component: () => import("/codebuild/output/src3498164433/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3498164433/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]